<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-5-columns">
      <section class="grid-container-5-columns__item--full-row">
        <q-card flat class="filter-card">
          <q-card-section class="filter-card__section">
            <TheSiteSelector v-on:updateFilter="handleFilterUpdate($event)" />
          </q-card-section>
        </q-card>
      </section>
      <section class="grid-container-5-columns__item--full-row">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <TheKPIList
              :filter="filterOption"
              dataset="LiveDashboard_Top5KPIs_Hourly"
            />
          </q-card-section>
        </q-card>
      </section>
      <section class="grid-container-5-columns__item--large">
        <q-card flat class="d3-card">
          <q-card-section class="d3-card__section">
            <LiveDashboardChart
              :filter="filterOption"
              title="Stake Wins GGR Per 5 Minutes Last 2 Hours"
              dataset="LiveDashboard_WagerWinsGGRPer5MinutesLast2Hours"
              height="500"
            />
            <TodaySummary
              :filter="filterOption"
              dataset="LiveDashboard_TodaySummary"
            />
          </q-card-section>
        </q-card>
      </section>

      <section
        class="grid-container-5-columns__item"
        v-for="(table, index) in tables"
        :key="index"
      >
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <DataTable
              :filter="filterOption"
              :title="table.title"
              :dataset="table.data"
              :timer="180000"
              v-on:loadPlayerDetails="handlePlayerSelection($event)"
            />
          </q-card-section>
        </q-card>
      </section>
      <PlayerDetails :player="selectedPlayer" />
    </div>
  </q-page>
</template>

<script>
import TheKPIList from "@/components/other/TheKPIList.vue";
import TheSiteSelector from "@/components/filters/TheSiteSelector.vue";
import LiveDashboardChart from "@/components/charts/LiveDashboardChart.vue";
import TodaySummary from "@/components/other/TheTodaySummary.vue";
import DataTable from "@/components/tables/DataTable.vue";
import PlayerDetails from "@/components/dialog/PlayerDetails.vue";

export default {
  name: "LiveDashboard",
  data() {
    return {
      filterOption: {
        siteId: 0,
        networkId: 0,
        operatorId: 0,
      },
      selectedSiteId: 0,
      selectedPlayer: {
        id: 0,
        site: "",
      },
      selectedPlayerSite: "",
      tables: [
        {
          title: "Top 10 Contributors Last 15 Minutes",
          data: "LiveDashboard_Top10ContributorsLast15Minutes",
        },
        {
          title: "Top 10 Contributors Today",
          data: "LiveDashboard_Top10ContributorsToday",
        },
        {
          title: "Top 10 Depositors Last 15 Minutes",
          data: "LiveDashboard_Top10DepositorsLast15Minutes",
        },
        {
          title: "Top 10 Depositors Today",
          data: "LiveDashboard_Top10DepositorsToday",
        },
        {
          title: "Top 10 Volume Last 15 Minutes",
          data: "LiveDashboard_Top10VolumeLast15Minutes",
        },
        {
          title: "Top 10 Volume Today",
          data: "LiveDashboard_Top10VolumeToday",
        },
        {
          title: "Top 10 Winners Last 15 Minutes",
          data: "LiveDashboard_Top10WinnersLast15Minutes",
        },
        {
          title: "Top 10 Winners Today",
          data: "LiveDashboard_Top10WinnersToday",
        },
      ],
    };
  },
  components: {
    LiveDashboardChart,
    TheSiteSelector,
    TodaySummary,
    TheKPIList,
    DataTable,
    PlayerDetails,
  },

  methods: {
    handleFilterUpdate: function(filterOption) {
      this.filterOption = filterOption;
    },
    handlePlayerSelection(loadPlayerDetails) {
      this.selectedPlayer = loadPlayerDetails;
    },
  },
};
</script>
